const s = "_title_1008n_1", e = "_size1_1008n_7", _ = "_size2_1008n_11", i = "_size3_1008n_14", t = "_size4_1008n_17", z = "_size5_1008n_20", n = "_size6_1008n_24", c = "_uppercase_1008n_28", o = {
  title: s,
  size1: e,
  size2: _,
  size3: i,
  size4: t,
  size5: z,
  size6: n,
  uppercase: c
};
export {
  o as default,
  e as size1,
  _ as size2,
  i as size3,
  t as size4,
  z as size5,
  n as size6,
  s as title,
  c as uppercase
};
//# sourceMappingURL=title.module.less.js.map
